import { useEffect, useRef } from 'react';
export var useInterval = function (callback, delay) {
    var savedCallback = useRef();
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
        var tick = function () {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
};
//# sourceMappingURL=index.js.map